import { userConstant } from '../constants';
import { userServices } from '../services/userService';

function loginUser(params) {
    return dispatch => {
        userServices.loginUser(params)
            .then(data => {
                dispatch({ type: userConstant.USER_LOGIN, payload: data })
            })
    }
}

function authenticateUser() {
    return dispatch => {
        const data = userServices.authenticateUser();
        dispatch({ type: userConstant.USER_AUTHENTICATION, payload: data });
    }
}

function userLogout() {
    return dispatch => {
        const data = userServices.userLogout();
        dispatch({ type: userConstant.USER_LOGOUT, payload: data });
    }
}

// function registerUser(params) {
//     return dispatch => {
//         userServices.registerUser(params)
//             .then(data => {
//                 dispatch({ type: userConstant.USER_REGISTER, payload: data })
//             })
//     }
// }

export const userActions = {
    loginUser,
    authenticateUser,
    userLogout
    // registerUser
}